import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from '../utils/dom'

export default function formContato() {
    function showMessage(response) {
        const message = response.data ? response.data.message : response.message
        showToastify(message)
        denunciaFormSubmit.reset()
        setTimeout(enabledBtn, 1000)
    }

    const btnSubmit = document.querySelector('#form-contato button[type=submit]')

    function disabledBtn() {
        btnSubmit.disabled = true
        btnSubmit.classList.add('disabled')
    }

    function enabledBtn() {
        btnSubmit.disabled = false
        btnSubmit.classList.remove('disabled')
    }


    const denunciaFormSubmit = document.querySelector('#form-contato');

    denunciaFormSubmit &&
        denunciaFormSubmit.addEventListener('submit', function (event) {
            event.preventDefault()
            disabledBtn()

            const formElement = document.querySelector('#form-contato');
            const formData = new FormData(formElement);
            const jsonData = Object.fromEntries(formData.entries());
						

            const url = '/fale-conosco/'

            axios
                .post(url, jsonData)
                .then((response) => showMessage(response))
                .catch((response) => showMessage(response))
        })

}